import React from 'react';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Input, EAA_Add_Btn, EAA_Date, EAA_Upload } from '~/components/EditAndAddItem';
import * as getTime from '~/skills/getTime';

const emptyBody = {
  industry_doc_date: '',
  industry_doc_num: '',
  industry_doc_upload_files: [],
};

const App = props => {
  const { titleWidth, disabled, checkSubChange, changeData, data } = props;
  const ary = data.sub3 || [];
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData({ label: 'sub3', data: dataAry });
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  const renderAry = [];
  for (let i = 0; i < ary.length; i++) {
    const isFirst = i === 0;
    renderAry.push(
      <EAA_Row key={`Page_IAManufacturingProgram_sub3_1_${i}`}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text='' />
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>(公文)發文日期</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>公文文號</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 + 154 }}>公文上傳(含附件)</div>
          </EAA_ItemContainer>
        </EAA_Item>
      </EAA_Row>,
    );
    renderAry.push(
      <EAA_Row key={`Page_IAManufacturingProgram_sub3_2_${i}`} style={{ marginTop: 0 }}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text={isFirst ? '公司來函' : ''} bol={isFirst} haveChange={checkSubChange(3, [emptyBody])} />
            <EAA_Date displayBorder disabled={disabled} marginRight={12} value={getTime.returnDate(ary[i].industry_doc_date)} onChange={data => { ary[i].industry_doc_date = getTime.getType3Time(data); saveSub(ary); }} />
            <EAA_Input displayBorder disabled={disabled} marginRight={12} value={ary[i].industry_doc_num} onChange={data => { ary[i].industry_doc_num = data; saveSub(ary); }} />
            <EAA_Upload displayBorder disabled={disabled} marginRight={12} value={ary[i].industry_doc_upload_files} onChange={data => { ary[i].industry_doc_upload_files = data; saveSub(ary); }} />
            <EAA_Add_Btn disabled={disabled} del={i > 0} onClick={(i > 0) ? () => delRow(i) : () => addRow()} />
          </EAA_ItemContainer>
          {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
        </EAA_Item>
      </EAA_Row>,
    );
  }
  return renderAry;
};
export default App;
